import {css, unsafeCSS} from 'lit';
import {sbkCoreBreakpointLg, sbkCoreBreakpointMd} from '@/tokens/variables.js'

const breakpointMd = unsafeCSS(`${sbkCoreBreakpointMd}`);
const breakpointLg = unsafeCSS(`${sbkCoreBreakpointLg}`);

export const style = css`
  :host {
    display: flex;
    box-sizing: border-box;
  }

  .icon {
    box-sizing: border-box;
    fill: currentColor;
  }

  .icon-16 {
    height: 16px;
    width: 16px;
  }

  .icon-20 {
    height: 20px;
    width: 20px;
  }

  .icon-24 {
    height: 24px;
    width: 24px;
  }

  .icon-32 {
    height: 32px;
    width: 32px;
  }

  .icon-40 {
    height: 40px;
    width: 40px;
  }

  .icon-64 {
    height: 64px;
    width: 64px;
  }

  .icon-88 {
    height: 88px;
    width: 88px;
  }

  .icon-112 {
    height: var(--sbkModalSizingImageHeight);
    width: var(--sbkModalSizingImageHeight);
  }

  .icon-160 {
    width: var(--sbkCitationSizingLargeScrBgIconSize);
    height: var(--sbkCitationSizingLargeScrBgIconSize);
  }

  .icon-160.responsive {
    width: var(--sbkCitationSizingSmallScrBgIconSize);
    height: var(--sbkCitationSizingSmallScrBgIconSize);

    @media (min-width: ${breakpointLg}) {
      width: var(--sbkCitationSizingLargeScrBgIconSize);
      height: var(--sbkCitationSizingLargeScrBgIconSize);
    }
  }

  .icon-24.responsive {
    height: 20px;
    width: 20px;

    @media screen and (min-width: ${breakpointMd}) {
      height: 24px;
      width: 24px;
    }
  }

  :host([symbol="badge-new-german"]), :host([symbol="badge-new-english"]) {
    display: inline-flex;
    margin-right: var(--sbkCoreSpacing4xs);
    vertical-align: text-bottom;
  }
`;
